/**
 * Session Configuration
 * Customize inactivity timeout and warning settings
 */

export const SESSION_CONFIG = {
  // Inactivity timeout in minutes
  INACTIVITY_TIMEOUT: 30, // 30 minutes
  
  // Warning time before logout in minutes
  WARNING_TIME: 5, // 5 minutes warning
  
  // Events that count as user activity
  ACTIVITY_EVENTS: [
    'mousedown', 'mousemove', 'keypress', 'scroll', 
    'touchstart', 'click', 'focus', 'keydown'
  ],
  
  // Enable/disable inactivity logout
  ENABLE_INACTIVITY_LOGOUT: true,
  
  // Enable/disable cross-tab synchronization
  ENABLE_CROSS_TAB_SYNC: true,
  
  // Show console logs for debugging
  DEBUG_MODE: false
};

// Convert minutes to milliseconds
export const getTimeoutMs = () => SESSION_CONFIG.INACTIVITY_TIMEOUT * 60 * 1000;
export const getWarningMs = () => SESSION_CONFIG.WARNING_TIME * 60 * 1000;